import { render, staticRenderFns } from "./Sheet_Materials.vue?vue&type=template&id=15d59af4&scoped=true"
import script from "./Sheet_Materials.vue?vue&type=script&lang=js"
export * from "./Sheet_Materials.vue?vue&type=script&lang=js"
import style0 from "./Sheet_Materials.vue?vue&type=style&index=0&id=15d59af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d59af4",
  null
  
)

export default component.exports